import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import PostCard from "@/components/PostCard";
import PostComposer from "@/components/PostComposer";
import CrisisResources from "@/components/CrisisResources";
import AnniversaryReminders from "@/components/AnniversaryReminders";
import { Sparkle, ArrowLeft } from "@phosphor-icons/react";
import usePageMeta from "@/lib/usePageMeta";

export default function Hub() {
  const { condition } = useParams();
  const cond = decodeURIComponent(condition);
  const isLoss = cond === "Pregnancy Loss";
  usePageMeta({ title: `${cond} Hub`, description: `Community stories, AI summaries, and lived-experience insights for women navigating ${cond}.` });
  const [posts, setPosts] = useState([]);
  const [summary, setSummary] = useState("");
  const [loading, setLoading] = useState(true);

  const load = async () => {
    const [p, s] = await Promise.all([
      api.get("/posts", { params: { condition: cond } }),
      api.get(`/hubs/${encodeURIComponent(cond)}/summary`),
    ]);
    setPosts(p.data.posts); setSummary(s.data.summary); setLoading(false);
  };
  useEffect(() => { load(); }, [cond]);

  return (
    <div className="max-w-4xl">
      <Link to="/app" data-testid="hub-back" className="text-sm text-muted-foreground hover:text-ink flex items-center gap-1.5 mb-6">
        <ArrowLeft size={14} /> Back to timeline
      </Link>
      <div className="text-xs tracking-[0.25em] uppercase text-sage-600 mb-3"><span className="rule" />Condition hub</div>
      <h1 className="font-display text-5xl leading-tight" data-testid="hub-title">{cond}</h1>

      {isLoss && (
        <div className="mt-8 space-y-5">
          <CrisisResources />
          <AnniversaryReminders />
        </div>
      )}

      <div className="mt-8 p-6 bg-sage-50 border border-sage-100 rounded-2xl">
        <div className="flex items-center gap-2 text-xs tracking-[0.2em] uppercase text-sage-700">
          <Sparkle size={16} weight="duotone" /> AI community summary
        </div>
        <p className="mt-3 text-ink/80 leading-relaxed" data-testid="hub-summary">
          {loading ? "Reading the room…" : summary}
        </p>
      </div>

      <div className="mt-10 space-y-5">
        <PostComposer condition={cond} onPosted={load} />
        <div className="space-y-4 stagger" data-testid="hub-posts">
          {loading ? <div className="text-muted-foreground">Loading…</div>
            : posts.length === 0 ? <div className="text-muted-foreground">No posts in this hub yet.</div>
            : posts.map(p => <PostCard key={p.id} post={p} onChanged={load} />)}
        </div>
      </div>
    </div>
  );
}
